export default "__VITE_ASSET__CxFbPtcD__"